import { loginUser, savePrevPath } from 'actions'
import store from 'main/store'
import dashboardApi from 'services/api/dashboard'
import LocalUserService from 'services/localUserService'
import { getSavedSubsidiary } from 'utils/helpers'

let isHandlingSessionExpired = false

export async function sessionExpiredHandler() {
  if (isHandlingSessionExpired) {
    return
  }

  const userService = new LocalUserService()
  const pathname = window.location.pathname

  if (pathname.includes('/login') || pathname.includes('/magic-link')) {
    return
  }

  const isSessionTimedOut = store.getState().login.sessionTimedOut
  const isSessionExpired = store.getState().login.sessionExpired

  if (isSessionExpired || isSessionTimedOut) {
    return // nothing to handle
  }

  isHandlingSessionExpired = true

  const location = window.location

  store.dispatch({ type: 'SESSION_TIMED_OUT' })

  if (!pathname.includes('/login') && !pathname.includes('selectHotel')) {
    store.dispatch(savePrevPath(`${location.pathname}${location.search}`))
  }

  const currentUserInfo = userService.getCurrentUserInfo()

  const lastGeoLocation = store.getState().signIn.geoLocation
  const subsidiaryId = store.getState().login.currentHotelId

  try {
    const savedSubsidiary = getSavedSubsidiary()
    const savedSubsidiaryId = savedSubsidiary && savedSubsidiary.subsidiaryId
    const uiSubsidiaryId =
      subsidiaryId || currentUserInfo?.subsidiaryId || savedSubsidiaryId

    const additionalData = {
      uiDashboardSessionId: currentUserInfo.sessionId,
      uiUserName: currentUserInfo?.user?.name,
      uiPath: document.location.pathname,
      uiGeolocation: JSON.stringify(lastGeoLocation),
      uiScreenResolution: `${window.screen.width}x${window.screen.height}`,
      uiSubsidiaryId
    }

    if (!uiSubsidiaryId) {
      console.warn("couldn't renew session, no subsidiaryId")

      await dashboardApi.log({
        level: 'Debug',
        message: `Not renewing session since subsidiaryId is destroyed`,
        additionalData
      })

      store.dispatch({ type: 'EXPIRE_SESSION' })
      return
    }

    await dashboardApi.log({
      level: 'Debug',
      message: `Will try to renew session for sessionId: ${currentUserInfo.sessionId}`,
      additionalData,
      rawData: JSON.stringify(getSavedSubsidiary())
    })

    const sessionRenewResponse = await dashboardApi.renewSession({
      sessionId: currentUserInfo.sessionId,
      userToken: currentUserInfo.userToken,
      geoLocation: lastGeoLocation,
      screen: `${window.screen.width}x${window.screen.height}`,
      subsidiaryId: subsidiaryId || savedSubsidiaryId
    })

    const renewResult = sessionRenewResponse?.result ?? sessionRenewResponse

    await dashboardApi.log({
      level: 'Debug',
      message: `Got renew session response: renewed ${Boolean(renewResult?.sessionId)}`,
      additionalData
    })
    if (renewResult?.sessionId) {
      userService.updateSessionInfo(
        renewResult.sessionId,
        renewResult.userToken,
        {
          userId: renewResult.userId,
          dashboardUserId: renewResult.dashboardUserId,
          subsidiaryId: subsidiaryId || savedSubsidiaryId
        }
      )
      // Notify Electron of updated token
      if (window?.electron?.postMessage) {
        const dashIdRaw = renewResult.dashboardUserId
        const dashId =
          dashIdRaw != null &&
          Number.isFinite(Number(dashIdRaw)) &&
          Number(dashIdRaw) > 0
            ? Number(dashIdRaw)
            : null
        window.electron.postMessage({
          type: 'token-updated',
          data: {
            spAuth: renewResult.sessionId,
            ...(renewResult.userToken ? { userToken: renewResult.userToken } : {}),
            ...(dashId != null ? { dashboardUserId: dashId } : {})
          }
        })
      }
      store.dispatch({
        type: 'SESSION_RENEWED',
        payload: renewResult.sessionId
      })
      store.dispatch(
        loginUser(
          currentUserInfo.user,
          renewResult.userToken,
          renewResult.userId,
          renewResult.sessionId
        )
      )
    } else {
      store.dispatch({ type: 'EXPIRE_SESSION' })
      console.warn("couldn't renew session", sessionRenewResponse)
    }
  } catch (error) {
    await dashboardApi.log({
      level: 'Error',
      message: `Couldn't renew session`,
      additionalData: {
        uiGeolocation: JSON.stringify(lastGeoLocation),
        uiPath: document.location.pathname,
        uiUserName: currentUserInfo?.user?.name,
        uiDashboardSessionId: currentUserInfo?.sessionId,
        uiScreenResolution: `${window.screen.width}x${window.screen.height}`
      }
    })

    console.warn("couldn't renew session", error)
    store.dispatch({ type: 'EXPIRE_SESSION' })

    if (window?.electron?.postMessage) {
      window.electron.postMessage({
        type: 'logged-out',
        data: {
          subsidiaryId,
          reason: 'session_expired'
        }
      })
    }
  } finally {
    isHandlingSessionExpired = false
  }
}
